/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApplicationScope,
  SyncConfig,
  SyncPreviewEntry,
  SyncResult,
} from '../models';
import {
    ApplicationScopeFromJSON,
    ApplicationScopeToJSON,
    SyncConfigFromJSON,
    SyncConfigToJSON,
    SyncPreviewEntryFromJSON,
    SyncPreviewEntryToJSON,
    SyncResultFromJSON,
    SyncResultToJSON,
} from '../models';

export interface GetSyncPreviewRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
}

export interface SyncDatabaseEntriesRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    requestBody?: Array<string>;
}

export interface UpdateSyncConfigRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    syncConfig?: SyncConfig;
}

/**
 * 
 */
export class DatabaseSyncControllerApi extends runtime.BaseAPI {

    /**
     * Zeigt alle neuen Einträge der Quell-Datenbank, die noch nicht synchronisiert wurden
     * Vorschau neuer Einträge aus Quell-DB
     */
    async getSyncPreviewRaw(requestParameters: GetSyncPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SyncPreviewEntry>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getSyncPreview.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling getSyncPreview.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/sync/preview`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SyncPreviewEntryFromJSON));
    }

    /**
     * Zeigt alle neuen Einträge der Quell-Datenbank, die noch nicht synchronisiert wurden
     * Vorschau neuer Einträge aus Quell-DB
     */
    async getSyncPreview(requestParameters: GetSyncPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SyncPreviewEntry>> {
        const response = await this.getSyncPreviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Ausgewählte oder alle neuen Einträge aus der Quell-Datenbank abrufen
     * Einträge aus Quell-DB synchronisieren
     */
    async syncDatabaseEntriesRaw(requestParameters: SyncDatabaseEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SyncResult>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling syncDatabaseEntries.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling syncDatabaseEntries.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/sync`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SyncResultFromJSON(jsonValue));
    }

    /**
     * Ausgewählte oder alle neuen Einträge aus der Quell-Datenbank abrufen
     * Einträge aus Quell-DB synchronisieren
     */
    async syncDatabaseEntries(requestParameters: SyncDatabaseEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SyncResult> {
        const response = await this.syncDatabaseEntriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sync-Konfiguration einer Datenbank aktualisieren (Quell-DB, Modus)
     * Sync-Konfiguration aktualisieren
     */
    async updateSyncConfigRaw(requestParameters: UpdateSyncConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateSyncConfig.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling updateSyncConfig.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/sync/config`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SyncConfigToJSON(requestParameters.syncConfig),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Sync-Konfiguration einer Datenbank aktualisieren (Quell-DB, Modus)
     * Sync-Konfiguration aktualisieren
     */
    async updateSyncConfig(requestParameters: UpdateSyncConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateSyncConfigRaw(requestParameters, initOverrides);
    }

}
